import React from "react";
import { Link } from "react-router-dom";
import NiteonLogo from "../../images/niteon-real.png";

const Logo = () => {
  return (
    <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link">
      <img className="logo-light logo-img" src={NiteonLogo} alt="logo" />
      <img className="logo-dark logo-img" src={NiteonLogo} alt="logo" />
      <img className="logo-small logo-img logo-img-small" src={NiteonLogo} alt="logo" />
    </Link>
  );
};

export default Logo;
